module.exports = __webpack_public_path__ + "img/invoice-de-female-mv.526534ae.png";